// extracted by mini-css-extract-plugin
export default {"wrapper":"AddTab_wrapper__NaxQ9","icon":"AddTab_icon__EYJvm"};